import type { NamespaceLearnTranslation } from '../../i18n-types';

const da_learn = {
  agreementPopup: {
    agreementConfirmation: 'Bemærk, at ved at klikke på <>"Jeg er enig"<>',
    button: {
      agree: 'Jeg er enig, lad os fortsætte',
      disagree: 'Nej tak',
    },
    joiningNetwork:
      'Du er ved at blive en del af vores netværk af dermo-professionelle, casebibliotek og meget mere.',
    readPrivacyAndTerms: {
      and: 'og',
      privacyPolicy: 'Privatlivspolitik',
      readAndUnderstood: 'bekræfter du, at du har læst og forstået Dermloops',
      termsOfUse: 'Brugsvilkår',
    },
    title: 'Brugsvilkår & Privatlivspolitik',
  },
  casesScreen: {
    correctnessTag: '{correct|{true: Korrekt, *: Ukorrekt}}',
    difficulty: {
      easy: 'Let',
      hard: 'Svær',
      medium: 'Mellem',
      noDifficulty: 'Ingen',
      veryHard: 'Meget svær',
    },
    list: {
      trainingPlaceholder: 'Fuldførte cases bliver listet her',
    },
    points: 'Point',
    title: {
      anamnesis: '{gender|{Male: Mand, Female: Kvinde, *: Person}} i {age}erne',
    },
    trainingCase: {
      feedbackHeader: {
        difficulty: 'Sværhedsgrad',
        partiallyCorrectInfo: {
          title: 'Ikke korrekt',
          messageLine1:
            'Svaret er <>ikke korrekt<>, men hører til i den rigtige kategori.',
          messageLine2: 'Der gives <>0<> point.',
          dismiss: 'Forstået',
        },
        seeExplanation: 'Se forklaring og tips',
      },
    },
  },
  courseScreen: {
    lesson: {
      type: '{lessonType|{Quiz: Quiz, Reading: Læsning}}',
    },
    level: {
      levelNumber: 'Niveau {level}',
    },
  },
  diagnosisStatisticDetailScreen: {
    analyticSection: {
      content: {
        completedCases: 'Fuldførte cases',
        overallAccuracy: 'Præcision',
      },
      title: 'Statistik for diagnosegruppe',
    },
    commonMistakeSection: {
      title: 'Dine hyppigste fejl for {diagnosisName|lowercase}',
    },
    learnMoreSection: {
      content: {
        readMore: 'Læs mere om {diagnosisName|lowercase}',
      },
      title: 'Lær mere',
    },
    subDiagnosisSection: {
      title: '{diagnosisName} underdiagnoser',
    },
  },
  general: {
    backText: 'Tilbage',
    homeText: 'Hjem',
    button: {
      restartApp: 'Genstart appen',
    },
    diagnosisItem: {
      read: 'Læs',
      whatToRead: 'Hvad vil du gerne læse?',
    },
    doneReading: 'Færdig med at læse',
    markAsRead: 'Marker som læst',
  },
  homeScreen: {
    dahtNudgePopup: {
      description:
        'Du har nu nået dit mål for dermatoskopi-træning i DAHT-forsøget. Gå venligst til daht.dermloop.io for at vurdere DAHT-cases og afslutte forsøget.',
      buttonText: 'Gå til DAHT',
      dismissText: 'Fortsæt i Learn',
      title: 'DAHT-træning gennemført',
    },
    controlGroupLocked: {
      title: 'Learn er låst',
      description:
        'Du får adgang til denne app, når du har gennemført det minimale antal DAHT-cases. Gå til daht.dermloop.io',
    },
    trainingCard: {
      actionTitle: '{started|{true: Fortsæt, false: Start}} quiz',
      notificationText:
        'Du vil snart få notifikationer, når du modtager klinisk feedback eller nogen har reageret på en forum-case, som du følger.',
      reminderText:
        '🔔 Det vil også være muligt at tilmelde sig daglige påmindelser om læringsmål. 🤓',
    },
    currentLevelCard: {
      currentLevel: 'Nuværende niveau',
      accuracy: 'Niveaupræcision',
    },
    trainingStats: {
      title: 'Træningsfremskridt',
      last7Days: 'Ugens cases',
      total: 'Antal cases',
    },
    dahtProgressCard: {
      title: 'Mine mål',
      dahtStatusIndicator: {
        onTrack: 'På sporet',
        atRisk: 'I risiko',
        challengeEnded: 'Udfordringen er slut',
        challengeCompleted: 'Udfordringen gennemført',
      },
      weeklyCases: 'Ugens cases',
      totalProgress: 'Samlet fremskridt',
      finalProgress: 'Endeligt fremskridt',
      totalCases: 'Antal cases',
      studyChallenge: '28-dages studieudfordring',
      daysLeft: '{days} dag{{e}} tilbage',
      challengeCompletedMessage:
        'Du klarede det! Tak for dit bidrag. Nu er det tid til at evaluere DAHT-cases. Gå til hjemmesiden: daht.dermloop.io',
      challengeEndedMessage:
        'Desværre nåede du ikke at afslutte alle cases inden for tidsrammen. Du er velkommen til at vurdere de resterende cases, hvis du ønsker at evaluere DAHT-cases uden for protokollen.',
    },
    articlesProgressCard: {
      title: 'Læsefremskridt',
      articlesCount: '{done}/{total} artikler',
      ongoingArticlesLabel: 'Fortsæt hvor du slap',
      getStartedLabel: 'Kom i gang',
      seeAll: 'Vis alle',
      bottomSheetTitle: 'Igangværende artikler',
      itemsCount: '{count} elementer',
    },
  },
  loginScreen: {
    loginText: 'Log ind / Kom i gang',
    loginFailedMessage:
      'Vi kunne ikke logge dig ind. Prøv igen, eller kontakt support, hvis problemet fortsætter.',
  },
  settingsScreen: {
    accountSection: {
      content: {
        changePassword: 'Skift adgangskode',
        changePasswordAlert: {
          message:
            'En e-mail er blevet sendt til <>{email}<> med instruktioner om, hvordan du skifter adgangskode.',
          title: 'Link til nulstilling af adgangskode sendt!',
        },
        changePasswordErrorAlert: {
          message: 'Noget gik galt',
          title: 'Åh nej!',
        },
        deleteAccount: 'Slet konto',
      },
      title: 'Konto',
    },
    supportSection: {
      content: {
        contactUs: 'Kontakt os',
      },
      title: 'Support',
    },
    legalSection: {
      content: {
        privacyPolicy: 'Privatlivspolitik',
        termsOfService: 'Vilkår og betingelser',
      },
      title: 'Vilkår og betingelser',
    },
    loggedInAs: 'Logget ind som',
    logout: 'Log ud',
    title: 'Indstillinger',
  },
  moreScreen: {
    title: 'Mere',
    getHelpSection: {
      title: 'Få hjælp',
      content: {
        reportProblem: 'Rapporter et problem',
        giveFeedback: 'Giv feedback',
      },
    },
    linksSection: {
      title: 'Links og information',
      content: {
        shareLearn: 'Del Learn',
        aboutMelatech: 'Om Melatech',
      },
    },
    productsSection: {
      title: 'Udforsk øvrige produkter',
      content: {
        exploreDermloop: 'Udforsk Dermloop',
        exploreSeranote: 'Udforsk Seranote',
      },
    },
    feedbackForm: {
      nameLabel: 'Navn',
      namePlaceholder: 'Dit navn',
      emailLabel: 'E-mail',
      emailPlaceholder: 'din.email@example.dk',
      cancelButtonLabel: 'Annuller',
      isRequiredLabel: '(påkrævet)',
      errorTitle: 'Fejl',
      formError: 'Udfyld venligst alle påkrævede felter.',
      emailError: 'Indtast venligst en gyldig e-mailadresse.',
      genericError: 'Feedback kunne ikke sendes på grund af en uventet fejl.',
      successMessageText: 'Tak for din henvendelse!',
      addScreenshotButtonLabel: 'Tilføj skærmbillede',
      removeScreenshotButtonLabel: 'Fjern skærmbillede',
      captureScreenshotError: 'Skærmbillede kunne ikke tages',
      reportProblem: {
        formTitle: 'Rapporter et problem',
        messageLabel: 'Beskrivelse',
        messagePlaceholder: 'Beskriv kort problemet...',
        submitButtonLabel: 'Send rapport',
      },
      giveFeedback: {
        formTitle: 'Giv feedback',
        messageLabel: 'Din feedback',
        messagePlaceholder: 'Del dine tanker med os...',
        submitButtonLabel: 'Send feedback',
      },
    },
  },
  statisticsScreen: {
    cardInfoTitle: {
      completedCases: 'Fuldførte cases',
    },
    levelProgress: {
      accuracy: 'nøjagtig',
      currentLevel: 'Nuværende niveau',
      noCasesYet: 'Ingen cases endnu',
      points: 'point',
      seeLess: 'Vis mindre',
      seeMore: 'Vis mere',
    },
    diagnosisGroupDetail: '{count} case{{count:s}} • {accuracy}% nøjagtig',
    sectionTitle: {
      diagnosticAccuracy: 'Diagnostisk nøjagtighed',
      diagnosticGroups: 'Diagnosegrupper',
      levelProgress: 'Niveauprogression',
    },
  },
  tabs: {
    cases: 'Cases',
    home: 'Hjem',
    statistics: 'Statistik',
    theory: 'Teori',
  },
  theoryScreen: {
    searchPlaceholder: 'Søg efter artikel',
    allArticles: 'Alle artikler',
    readButton: 'Læs',
    articleStatus: {
      notStarted: 'Ikke startet',
      inProgress: 'Igangværende',
      done: 'Færdig',
    },
  },
  trainingScreen: {
    diagnosisLibrarySearch: 'Søg på artikel',
    practiceList: {
      courseSection: {
        itemDescription: 'Kursus',
        sectionTitle: 'Kurser',
      },
      quizSection: {
        itemTitle: 'Træn diagnostik',
        nrOfCase: '{nrOfCases} case{{s}}',
        sectionTitle: 'Hurtig start',
      },
      sectionType: {
        course: 'Kursus',
        quiz: 'Quiz',
      },
      startButton: '{started|{true: Fortsæt, *: Start}}',
      title: 'Overblik',
    },
    title: {
      diagnosisLibrary: 'Diagnosebibliotek',
      practice: 'Træning',
    },
  },
  trainingSession: {
    anamnesis: '{gender|{Male: Mand, Female: Kvinde, *: Person}} i {age}erne',
    annotation: {
      noAnnotationCard: {
        continueButton: 'Du har anmodet om en forklaring',
        description:
          'Vi har ikke annoterede dermoskopiske kriterier for denne træningslesion. Men du kan bede om en forklaring, så annoterer vi læsionen så hurtigt som muligt.',
        requestButton: 'Anmod om forklaring',
        title: 'Beklager!',
      },
      notDisplayed: 'Ikke vist',
      title: 'Forklaring',
    },
    assessed: {
      correctAnswer: 'Korrekt svar',
      yourAnswer: 'Dit svar',
    },
    backText: 'Tilbage',
    difficultyLevelChange: {
      failure: {
        continueButton: 'Fortsæt på Niveau {level}',
        description:
          'Vi foreslår, at du går tilbage til Niveau {level} og øver dig på nemmere cases',
        downgradeButton: 'Gå tilbage til Niveau {level}',
        title: 'Ups - din præcision er under {accuracy}%!',
      },
      levelDescription: 'Niveau {level} - {levelName}!',
      nextLevel: {
        title: 'Du er nu på',
      },
      progressionRequirement: {
        accuracyForCases: 'Præcision ({nrOfCases} case{{s}})',
        minAccuracy: 'Min. {accuracy}%',
        title: 'Krav for at gennemføre niveauet:',
      },
      success: {
        continueButton: 'Fortsæt',
        description: 'Du har gennemført',
        title: 'Tillykke!',
      },
    },
    footerConfirmButton: 'Tjek svar',
    footerContinueButton: 'Næste',
    goback: 'Gå tilbage',
    quizError: 'Der opstod en fejl under opstart af quizzen',
    quizNumber: 'Quiz #{number}',
    reportProblem: {
      cancel: 'Annuller',
      close: 'Luk',
      description: 'Beskriv problemet',
      problemTextFieldPlaceholder: 'Beskriv kort problemet her...',
      submit: 'Send',
      submitted: {
        error:
          'Der opstod en fejl under indsendelsen af din rapport. Vores udviklere er blevet informeret. Prøv venligst igen.',
        success: 'Din rapport er blevet indsendt. Tak for din feedback.',
      },
      title: 'Rapportér et problem',
    },
    selectDiagnosis: 'Vælg diagnose',
    statistic: {
      accuracyHeading: 'Diagnostisk nøjagtighed',
      averageDifficulty: 'Gennemsnitlig sværhedsgrad',
      cases: 'Cases',
      correctAnswers: 'Korrekte svar',
      correctAnswersRatio: 'Korrekte svar • {correct}/{total}',
      courseAccuracyCard: {
        courseFailureButton: 'Gentag lektion',
        courseSuccessButton: 'Næste lektion',
      },
      level: 'Session niveau',
      points: '{count} point',
      quizAccuracyCard: {
        nextSessionButton: 'Næste quiz',
      },
      quizResultHeader: 'Resultat',
      secondAbbreviated: 'sek.',
      seeMore: 'Vis mere',
      time: 'Tid per case',
      timePerCase: 'Tid per case (sek.)',
      title: 'Statistik',
    },
  },
} satisfies NamespaceLearnTranslation;

export default da_learn;
